import { fetchData, apiURL } from "../api-helper";

const loginUser = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/users/login`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getUsers = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/users`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createUser = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/users`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const editUser = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/users/${payload.id}`;
    const body = {
      role: payload.role,
      password: payload.password,
      email: payload.email,
      par_id: payload.role === 1 ? payload.par_id : null,
    };
    fetchData(endpointURL, "put", body)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteUser = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/users/${payload}`;
    fetchData(endpointURL, "delete")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getPartners = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/partners`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getPartnersLogo = (id) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/partners/${id}/logo`;
    fetchData(endpointURL, "get", null)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const editPartner = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/partners/${payload.get("id")}`;
    fetchData(endpointURL, "postform", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deletePartner = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/partners/${payload}`;
    fetchData(endpointURL, "delete")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const changePassword = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/resetPassword`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const forgotPassword = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/forgotPassword`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getConductors = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/validationUsers`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createConductor = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/validationUsers`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteConductor = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/validationUsers/${payload}`;
    fetchData(endpointURL, "delete")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const editConductor = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/validationUsers/${payload.id}`;
    const body = {
      username: payload.username,
      fullname: payload.fullname,
      password: payload.password === "" ? null : payload.password,
      par_id: payload.par_id,
      active: payload.active,
    };
    fetchData(endpointURL, "put", body)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getOrders = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/orders`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getUserOrder = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/orders/${payload.id}`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getWebshopUserType = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/users/type`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createWebshopUserType = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/users/type`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const editTicketBuyerType = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/users/type/${payload.id}`;
    const body = {
      title: payload.name,
    };
    fetchData(endpointURL, "put", body)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteTicketBuyerType = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/users/type/${payload}`;
    fetchData(endpointURL, "delete")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getTicketBuyers = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/webshopUser`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const addTicketBuyerTypeToTicketBuyer = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/webshopUser/${payload.id}`;
    const body = {
      type_id: payload.type_id,
    };
    fetchData(endpointURL, "put", body)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

// Billing and Payment Settings

const getSettingsForProvider = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/partners/${payload.id}/settings`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createSettingsForProvider = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/partners/${payload.id}/settings`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateSettingsForProvider = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/partners/${payload.id}/settings`;
    fetchData(endpointURL, "put", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteSettingsForProvider = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/partners/${payload.id}/settings`;
    fetchData(endpointURL, "delete", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getUsedTickets = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/orders/used`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getOrderIcal = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/orders/${payload.order_id}/event`;
    fetchData(endpointURL, "get", {}, "arraybuffer")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  loginUser,
  getUsers,
  createUser,
  editUser,
  deleteUser,
  getPartners,
  getPartnersLogo,
  editPartner,
  deletePartner,
  changePassword,
  forgotPassword,
  getConductors,
  createConductor,
  deleteConductor,
  editConductor,
  getOrders,
  getUserOrder,
  getWebshopUserType,
  createWebshopUserType,
  editTicketBuyerType,
  deleteTicketBuyerType,
  getTicketBuyers,
  addTicketBuyerTypeToTicketBuyer,
  getUsedTickets,
  getSettingsForProvider,
  createSettingsForProvider,
  updateSettingsForProvider,
  deleteSettingsForProvider,
  getOrderIcal,
};
